import type { ICallbackConfig } from '@commons/bo-ui/notifications/notif';
import type { NotifStatus } from '@commons/bo-ui/notifications/notif-status.enum';

import { Injectable } from '@angular/core';
import { Notif } from '@commons/bo-ui/notifications/notif';
import { ReplaySubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  readonly #notification: ReplaySubject<Notif> = new ReplaySubject<Notif>();
  readonly #clearToasts: ReplaySubject<void> = new ReplaySubject<void>();
  readonly #clearLastToast: ReplaySubject<void> = new ReplaySubject<void>();

  get notification(): ReplaySubject<Notif> {
    return this.#notification;
  }

  get clearToasts(): ReplaySubject<void> {
    return this.#clearToasts;
  }

  get clearLastToast(): ReplaySubject<void> {
    return this.#clearLastToast;
  }

  createToast(
    message: string,
    style?: NotifStatus,
    duration?: number,
    callbackConfig?: ICallbackConfig,
    callback?: (args?: unknown) => unknown,
    canCancelled = false,
    cancelCallback?: (args?: unknown) => unknown
  ): void {
    this.notification.next(
      new Notif({
        message,
        style,
        duration,
        callbackConfig,
        callback,
        canCancelled,
        cancelCallback,
      })
    );
  }

  clear(): void {
    this.clearToasts.next();
  }

  clearLast(): void {
    this.clearLastToast.next();
  }
}
